import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, Platform, ViewController} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";


@Component({
  selector: 'page-monthly-logs-report',
  templateUrl: 'monthly-logs-report.html',
})
export class MonthlyLogsReportPage {

  DailyLogsRport:any;

  constructor(public navCtrl: NavController,
              public service: ServiceProvider,
              public viewCtrl: ViewController,
              public loadingCtrl: LoadingController,
              public platform : Platform,
              public navParams: NavParams) {

    this.platform.ready().then(() => {

      this.loadvalues();
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MonthlyLogsReportPage');
  }

  loadvalues(){

    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });

    loading.present();

    this.DailyLogsRport = [];

    this.service.httpcall('app_web_service/get_monthly_logs_report?').subscribe(data => {

      this.DailyLogsRport = data;
      console.log('STDWiseReport',this.DailyLogsRport);
      loading.dismiss();
    })
  }

  doRefresh(refresher) {
    console.log('Begin async operation', refresher);

    this.loadvalues();

    setTimeout(() => {
      console.log('Async operation has ended');

      refresher.complete();
    }, 2000);
  }

  backBTN() {
    this.viewCtrl.dismiss();
  }


}



// WEBPACK FOOTER //
// ./src/pages/monthly-logs-report/monthly-logs-report.ts